import { Vue, Options } from 'vue-class-component';

import plantsClient from '@/core/services/plants';
import configurationsClient from '@/core/services/configurations-service';
import { GateDTO } from '@/../client-generator/generated-clients/plants';
import debounce from 'lodash.debounce';
import { FETCH_PLANT, HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import { NamingService } from '@/core/services/naming.service';
import {
  NAME_VALIDATION_DEBOUNCE_TIME,
  getRoomIconFromType,
} from '@/core/utils/utils';

@Options({
  name: 'DialogConfigureGate',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    plantId: {
      type: Number,
      requred: true,
    },
    gateId: {
      type: String,
      requred: true,
    },
    gate: {
      type: (Object as unknown) as GateDTO,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog', 'update-list'],
})
export default class DialogConfigureRoom extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;
  isLoading = false;

  plantId!: number;
  gateId!: string;
  gate!: GateDTO;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }

  async doSubmit() {
    this.isLoading = true;

    try {
      alert('TODO: update gate API call');
      this.$emitter.emit(FETCH_PLANT);
      this.handleHideDialog();
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-entranceplant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.isLoading = false;
    }
  }
}
